import React, {PureComponent} from "react";
import get from "lodash/get";
import {withApollo} from "react-apollo";
import userPermissionQuery from "../../User/queries/userPermissionQuery";

export const UserPermissionContext = React.createContext();

/**
 * This class wraps a component and exposes user permissions
 * to the context api which is then available to all nested components.
 */
class UserPermissionProvider extends PureComponent {
    state = {
        permissions: false,
    };

    getUserPermissions = async () => {
        const result = await this.props.client.query({
            query: userPermissionQuery,
        });

        this.setState({
            permissions: get(result, "data.userPermissions.permissions", []),
        });
    };

    render() {
        return (
            <UserPermissionContext.Provider
                value={{
                    getUserPermissions: this.getUserPermissions,
                    permissions: get(this.state, "permissions", false),
                }}
            >
                {this.props.children}
            </UserPermissionContext.Provider>
        );
    }
}

export default withApollo(UserPermissionProvider);
